import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferSection() {
  return <section id="oferta" className="bg-navy-900 text-white py-20 md:py-32 px-4 relative overflow-hidden scroll-mt-4" data-id="element-110">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/10 blur-[100px] rounded-full pointer-events-none" data-id="element-111"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-8" data-id="element-113">
          <h2 className="text-3xl md:text-5xl font-extrabold leading-tight" data-id="element-114">
            Es hora de dejar de ser víctima de la inflación y convertirte en{' '}
            <span className="text-gold" data-id="element-115">dueña de tu propia economía.</span>
          </h2>

          <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-116">
            No necesitas un préstamo bancario ni un milagro, necesitas un
            sistema que funcione en el mundo real de los Estados Unidos.
          </p>

          <div className="bg-navy-800/80 backdrop-blur-sm border border-gold/30 rounded-3xl p-8 md:p-12 max-w-2xl mx-auto mt-12 shadow-2xl" data-id="element-117">
            <h3 className="text-2xl font-bold mb-6" data-id="element-118">
              Obtén acceso inmediato a "Anti-Inflación USA"
            </h3>

            <div className="flex flex-col items-center justify-center space-y-2 mb-8" data-id="element-119">
              <div className="text-slate-400 text-lg" data-id="element-120">
                Precio regular: <span className="line-through" data-id="element-121">$19.99 USD</span>
              </div>
              <div className="flex items-center justify-center gap-4" data-id="element-122">
                <span className="text-xl text-gold font-bold" data-id="element-123">
                  Solo por hoy
                </span>
                <span className="text-6xl md:text-7xl font-extrabold text-white" data-id="element-124">
                  $6.39
                </span>
              </div>
              <div className="bg-gold text-navy-900 font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider mt-2 animate-pulse" data-id="element-125">
                68% OFF
              </div>
            </div>

            <CTAButton text="¡SÍ, QUIERO EMPEZAR MI TIENDA AHORA!" href="https://www.gananciasdigitalespro.com/cart/44126482137223:1" size="xl" className="w-full mb-6" data-id="element-126" />

            <div className="flex items-center justify-center text-slate-400 text-sm gap-2" data-id="element-127">
              <ShieldCheckIcon className="w-5 h-5 text-green-500" data-id="element-128" />
              <span data-id="element-129">
                Acceso instantáneo tras la compra. Pago 100% seguro y
                encriptado.
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}